<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                <van-col span="12">
                    <div class="banner-title">身体状态</div>
                </van-col>
            </van-row>
        </div>
        <div class="cond-box">
            <div class="cond-item">
                <div class="cond-left">体能年龄</div>
                <div class="cond-right">{{condition.fitnessAge.value}}</div>
            </div>
            <div class="cond-item">
                <div class="cond-left">体能等级</div>
                <div class="cond-right">{{condition.staminaLevel.value}}</div>
            </div>
            <div class="cond-item">
                <div class="cond-left">训练负荷</div>
                <div class="cond-right">{{condition.trainingLoad.value}}</div>
            </div>
            <div class="cond-item">
                <div class="cond-left">训练状态</div>
                <div class="cond-right">{{condition.trainingStatus.value}}</div>
            </div>
            <div class="cond-item">
                <div class="cond-left">最大摄氧量</div>
                <div class="cond-right">{{condition.vo2max.value}}<span class="unit" v-if="vo2maxValid">毫升/千克/分钟</span>
                </div>
            </div>
            <div class="cond-item">
                <div class="cond-left">乳酸阈</div>
                <div class="cond-right" v-if="!lactateHrValid">{{condition.lactateHr.value}}</div>
                <div class="cond-right" v-if="lactateHrValid">{{condition.lactatePace.value}}<span
                        class="unit">/公里，</span>{{condition.lactateHr.value}}<span class="unit">次/分钟</span></div>
            </div>
            <div class="cond-forecast" @click="toForecast">
                <div class="cond-left">成绩预测</div>
                <img class="forecast-icon" src="@/assets/share/friendDesc/to.png">
            </div>
        </div>
    </div>
</template>

<script>
    import {SwitchTimeToM} from "../../utils/dateUtils";

    export default {
        name: 'condition',
        data() {
            return {
                sharerId: localStorage.getItem('sharerId'),
                condition: {},
                vo2maxValid: 0,
                lactateHrValid: 0
            }
        },
        mounted() {
            this.getCondition();
        },
        methods: {
            back() {
                this.$router.back();
            },
            toForecast() {
                this.$router.push({
                    name: 'forecast'
                })
            },
            getCondition() {
                this.$api.share.friendBodyStatus({
                    sharerId: this.sharerId
                }).then(res => {
                    this.condition = res.info
                    if (!(this.condition.fitnessAge && this.condition.fitnessAge.value)) {
                        this.condition.fitnessAge = {value: '暂无数据'}
                    }
                    if (!(this.condition.staminaLevel && this.condition.staminaLevel.value)) {
                        this.condition.staminaLevel = {value: '暂无数据'}
                    } else {
                        this.condition.staminaLevel.value = this.getStaminaLevel(this.condition.staminaLevel.value);
                    }

                    if (!(this.condition.trainingLoad && this.condition.trainingLoad.value)) {
                        this.condition.trainingLoad = {value: '暂无数据'}
                    } else {
                        this.condition.trainingLoad.value = this.getTrainLoad(this.condition.trainingLoad.value);
                    }

                    if (!(this.condition.trainingStatus && this.condition.trainingStatus.value)) {
                        this.condition.trainingStatus = {value: '暂无数据'}
                    } else {
                        this.condition.trainingStatus.value = this.getTrainStatus(this.condition.trainingStatus.value);
                    }

                    if (!(this.condition.vo2max && this.condition.vo2max.value)) {
                        this.condition.vo2max = {value: '暂无数据'}
                    } else {
                        this.vo2maxValid = 1
                    }

                    if (!(this.condition.lactateHr && this.condition.lactateHr.value)) {
                        this.condition.lactateHr = {value: '暂无数据'}
                    } else {
                        this.lactateHrValid = 1
                        this.condition.lactatePace.value = SwitchTimeToM(this.condition.lactatePace.value);
                    }

                })
            },
            // 体能等级
            getStaminaLevel(num) {
                let l;
                if (num >= 10 && num < 20) {
                    l = "初学者";
                } else if (num < 30) {
                    l = "运动新手";
                } else if (num < 40) {
                    l = "挑战者";
                } else if (num < 50) {
                    l = "运动者";
                } else if (num < 60) {
                    l = "运动爱好者";
                } else if (num < 70) {
                    l = "运动狂热者";
                } else if (num < 81) {
                    l = "菁英运动员";
                }
                return l;
            },
            // 训练负荷
            getTrainLoad(num) {
                let r;
                if (num < 0.8) {
                    r = '低';
                } else if (num < 1.5) {
                    r = '最佳';
                } else {
                    r = '高';
                }
                return r;
            },
            // 训练状态
            getTrainStatus(num) {
                let r;

                if (num == 0) {
                    r = '无状态期';
                } else if (num == 1) {
                    r = '过度训练期';
                } else if (num == 2) {
                    r = '停止训练期';
                } else if (num == 3) {
                    r = '退步期';
                } else if (num == 4) {
                    r = '维持期';
                } else if (num == 5) {
                    r = '恢复期';
                } else if (num == 6) {
                    r = '进步期';
                } else if (num == 7) {
                    r = '减量期';
                }
                return r;
            },
        }
    }
</script>

<style scoped>

    .cond-box {
        width: 345px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        margin: 15px auto 0;
    }

    .cond-item {
        width: 100%;
        height: 50px;
        border-bottom: 1px solid #000000;
        position: relative;
    }

    .cond-item div {
        font-size: 14px;
        color: #ffffff;
        opacity: 0.9;
    }

    .cond-left {
        position: absolute;
        left: 20px;
        top: 16px;
    }

    .cond-right {
        position: absolute;
        top: 16px;
        right: 14px;
    }

    .unit {
        font-size: 12px;
        opacity: 0.6;
        margin-left: 3px;
    }

    .cond-forecast {
        width: 100%;
        height: 63px;
        position: relative;
    }

    .cond-forecast div {
        font-size: 14px;
        color: #ffffff;
        opacity: 0.9;
    }

    .forecast-icon {
        width: 16px;
        position: absolute;
        right: 10px;
        top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/condition.vue